import { useRecoilValue } from 'recoil';

import { paymentMethodChangeAcceptance } from '../atoms/paymentMethodChangeAcceptance';

export default function usePaymentMethodChangeAcceptance() {
  return useRecoilValue(paymentMethodChangeAcceptance);
}
